import { canAccessRoute } from '../../utils/routeAccess';
import React from 'react';
import {
    
    Users, LayoutDashboard, ShieldPlus, ShieldCheck,
    Store, Notebook, Contact, TicketPercent,
    UserRoundCheck, IdCard, Warehouse, Banknote, BarChart3, Building2, Mail,
    Receipt, CalendarDays, History, Sparkles
} from 'lucide-react';

const colors = {
    primary: '#3564db',
    primaryDark: '#274f9d',
    secondary: '#3564db',
    secondaryLight: '#92b1ed',
    accentDark: '#EC8400',
};

export interface NavItem {
    id: string;
    label: string;
    icon: React.ReactNode;
    color: string;
    links: { href: string; label: string; desc: string; icon?: React.ReactNode }[];
}

export const navItems: NavItem[] = [
    {
        id: 'dashboard', label: 'Dashboard', icon: <LayoutDashboard size={16} />, color:'var(--ad-link, #2854c5)',
        links: [
            { href: '/dashboard', label: 'Dashboard Financiero', desc: 'Resumen financiero general' },
            { href: '/dashboard-score', label: 'Dashboard Score', desc: 'Métricas de rendimiento' },
        ],
    },
    {
        id: 'correspondencia', label: 'Correspondencia', icon: <Mail size={16} />, color:'var(--ad-link, #2854c5)',
        links: [
            { href: '/config-correspondencia', label: 'Configuración de correspondencia', desc: 'Planes y condiciones de recepción' },
            { href: '/correspondencias', label: 'Gestión de Correspondencia', desc: 'Panel de paquetes, códigos y entregas' },
        ],
    },
    {
        id: 'Productos', label: 'Productos', icon: <Store size={16} />, color:'var(--ad-link, #2854c5)',
        links: [
            { href: '/categoriasproductos', label: 'Categorías productos', desc: 'Gestiona las categorías de los productos' },
            { href: '/productos', label: 'Productos', desc: 'Lista completa de productos' },
        ],
    },
    {
        id: 'servicios', label: 'Servicios', icon: <Store size={16} />, color:'var(--ad-link, #2854c5)',
        links: [
            { href: '/categorias', label: 'Categorías', desc: 'Gestiona las categorías de servicios' },
            { href: '/services', label: 'Servicios', desc: 'Lista completa de servicios' },
            { href: '/spaces', label: 'Espacios', desc: 'Administra los espacios disponibles' },
            { href: '/spaces-services', label: 'Espacios de Servicios', desc: 'Relaciona espacios con servicios' },
        ],
    },
    {
        id: 'planes', label: 'Planes', icon: <Notebook size={16} />, color: colors.accentDark,
        links: [
            { href: '/plan', label: 'Planes', desc: 'Ver y gestionar planes' },
            { href: '/priceplan', label: 'Precios de Planes', desc: 'Configura tarifas por plan' },
            { href: '/planconfig', label: 'Configuración de Planes', desc: 'Ajustes avanzados de planes' },
        ],
    },
    {
        id: 'pos', label: 'Punto de venta', icon: <Store size={16} />, color:'var(--ad-link, #2854c5)',
        links: [
            { href: '/pos-list', label: 'Puntos de venta', desc: 'Panel principal de reservas', icon: <Store size={15} /> },
            { href: '/point-of-sale', label: 'Operación del POS', desc: 'Reservas, recepción, cafetería y cobros', icon: <Store size={15} /> },
            { href: '/reservas', label: 'Ordenes', desc: 'Listado de todas las reservas', icon: <Receipt size={15} /> },
            { href: '/reservas-calendario', label: 'Reservas Calendario', desc: 'Vista de calendario interactivo', icon: <CalendarDays size={15} /> },
            { href: '/sesiones-de-pos', label: 'Sesiones del POS', desc: 'Historial de sesiones POS', icon: <History size={15} /> },
            { href: '/sugerencias-citas', label: 'Reservas recomendadas', desc: 'Sugerencias automáticas de citas', icon: <Sparkles size={15} /> },
        ],
    },
    {
        id: 'reports', label: 'Reportes', icon: <BarChart3 size={16} />, color:'var(--ad-link, #2854c5)',
        links: [
            { href: '/reportes/inventario-productos', label: 'Inventario de productos', desc: 'Productos con stock, sin stock y sin control' },
            { href: '/reportes/inventario-servicios', label: 'Inventario de servicios', desc: 'Espacios y capacidad por servicio' },
            { href: '/reportes/reservas', label: 'Reservas', desc: 'Ocupación y estado de reservas' },
            { href: '/reportes/cafeteria', label: 'Ventas de cafetería', desc: 'Ventas, cobros y saldos' },
            { href: '/reportes/cancelaciones', label: 'Cancelaciones de reservas', desc: 'Historial y motivos de cancelación' },
            { href: '/reportes/horas-regalo', label: 'Horas de regalo', desc: 'Consumo del titular y asociados' },
            { href: '/reportes/deudas', label: 'Deudas de clientes', desc: 'Saldos pendientes del titular' },
            { href: '/reportes/pagos-sesiones', label: 'Pagos por sesiones POS', desc: 'Apertura, reservas y operadores de cobro' },
            { href: '/reportes/pagos', label: 'Pagos', desc: 'Ingresos y medios de pago' },
            { href: '/reportes/caja', label: 'Caja', desc: 'Movimientos y cierres de caja' },
            { href: '/reportes/uso', label: 'Uso', desc: 'Uso de espacios y servicios' },
            { href: '/reportes/clientes', label: 'Clientes', desc: 'Actividad y recurrencia de clientes' },
            { href: '/reportes/actividad', label: 'Actividad', desc: 'Auditoría de acciones administrativas' },
            { href: '/reportes/seguridad', label: 'Seguridad', desc: 'Accesos y eventos de seguridad' },
        ],
    },
    {
        id: 'empresa', label: 'Empresa', icon: <Building2 size={16} />, color: colors.accentDark,
        links: [
            { href: '/empresa', label: 'Empresa y Facturación', desc: 'Compañías, SIAT, CUIS, CUFD y facturas' },
        ],
    },
    {
        id: 'sucursales', label: 'Sucursales', icon: <Warehouse size={16} />, color:'var(--ad-link, #2854c5)',
        links: [
            { href: '/sucursales', label: 'Sucursales', desc: 'Gestiona las sedes de la empresa' },
        ],
    },
    {
        id: 'kardex', label: 'Kardex', icon: <IdCard size={16} />, color:'var(--ad-link, #2854c5)',
        links: [
            { href: '/kardex-citas', label: 'Kardex de Citas', desc: 'Registro histórico de citas' },
            { href: '/afiliados', label: 'Afiliados & Requisitos', desc: 'Flujo Miro de afiliación y 8h cortesía' },
        ],
    },
    {
        id: 'coupon', label: 'Cupones', icon: <TicketPercent size={16} />, color: colors.accentDark,
        links: [
            { href: '/coupon', label: 'Cupones', desc: 'Crea y administra cupones' },
            { href: '/coupon-used', label: 'Cupones Usados', desc: 'Historial de cupones canjeados' },
        ],
    },
    {
        id: 'system', label: 'Sistema', icon: <UserRoundCheck size={16} />, color:'var(--ad-link, #2854c5)',
        links: [
            { href: '/system', label: 'Sistema', desc: 'Configuración global del sistema' },
        ],
    },
    {
        id: 'users', label: 'Usuarios', icon: <Users size={16} />, color:'var(--ad-link, #2854c5)',
        links: [
            { href: '/usuarios', label: 'Usuarios', desc: 'Listado de usuarios registrados' },
            { href: '/nivelusuarios', label: 'Nivel de Usuarios', desc: 'Categorías y rangos de usuarios' },
            { href: '/reglas-nivel', label: 'Reglas de Nivel', desc: 'Define reglas por nivel de usuario' },
        ],
    },
    {
        id: 'actors-systems', label: 'Actores', icon: <Contact size={16} />, color:'var(--ad-link, #2854c5)',
        links: [
            { href: '/clients', label: 'Clientes', desc: 'Base de datos de clientes' },
            { href: '/personnel', label: 'Personal', desc: 'Gestión del equipo interno' },
        ],
    },
    {
        id: 'order', label: 'Órdenes', icon: <IdCard size={16} />, color: colors.accentDark,
        links: [
            {
                href: '/codigos-orden',
                label: 'Código de Orden',
                desc: 'Gestiona códigos de órdenes',
            },
            {
                href: '/codigo-pago-orden',
                label: 'Código de Pagos',
                desc: 'Códigos relacionados a pagos',
            },
            {
                href: '/codigo-sesionpos-orden',
                label: 'Código de Sesión POS',
                desc: 'Códigos de sesiones POS',
            },
        ],
    },
    {
        id: 'pagos', label: 'Pagos', icon: <Banknote size={16} />, color:'var(--ad-link, #2854c5)',
        links: [
            { href: '/pagos', label: 'Todos los Pagos', desc: 'Historial completo de pagos registrados' },
            { href: '/tipos-pago', label: 'Tipos de Pago', desc: 'Métodos de pago aceptados' },
            { href: '/config-pago', label: 'Configuración de Pagos', desc: 'Ajustes de pasarela de pago' },
        ]
    },
    {
        id: 'config', label: 'Configuración', icon: <ShieldPlus size={16} />, color:'var(--ad-link, #2854c5)',
        links: [
            { href: '/profile', label: 'Perfil', desc: 'Tu información de perfil' },
            { href: '/permission', label: 'Permisos', desc: 'Roles y permisos del sistema' },
            { href: '/config-registro', label: 'Registro de clientes', desc: 'Nivel inicial de los nuevos clientes' },
            { href: '/config-horas-regalo', label: 'Config. Horas de Regalo', desc: 'Horas de cortesía por plan' },
            { href: '/config-correspondencia', label: 'Config. Correspondencia', desc: 'Gestión de correspondencia' },
        ],
    },
    {
        id: 'historial', label: 'Historial', icon: <ShieldCheck size={16} />, color:'var(--ad-link, #2854c5)',
        links: [
            { href: '/activity', label: 'Actividades', desc: 'Registro de actividad del sistema' },
            { href: '/security', label: 'Seguridad', desc: 'Eventos y alertas de seguridad' },
            { href: '/seguridad/recuperaciones', label: 'Recuperación de cuentas', desc: 'Revisión de identidad y acceso' },
        ],
    },
    {
        id: 'landing', label: 'Landing', icon: <Notebook size={16} />, color: colors.accentDark,
        links: [
            { href: '/banner-hero', label: 'Banner & Secciones Landing', desc: 'Hero banner, galería, experiencia y secciones' },
            { href: '/blog-categoria', label: 'Categorías de Blog', desc: 'Gestiona las categorías del blog' },
            { href: '/blog-post', label: 'Publicaciones de Blog', desc: 'Crea y administra publicaciones' },
            { href: '/empresas-confianza', label: 'Empresas de Confianza', desc: 'Gestiona las empresas de confianza en la landing' },
            { href: '/ramas-profesionales', label: 'Ramas Profesionales', desc: 'Gestiona las ramas y sub-ramas del banco' },
            { href: '/eventos-admin', label: 'Eventos & Networking', desc: 'Gestiona eventos, networking y asistentes' },
        ],
    },
];


export function filterAdminNavigation(role: string | null | undefined, permissions: Record<string, string[]>, disabledPaths: readonly string[] = [], loading = false) {
    return navItems.map(item => ({ ...item, links: loading ? [] : item.links.filter(link => canAccessRoute(link.href, role, permissions, disabledPaths)) })).filter(item => item.links.length > 0);
}

